module.exports = __webpack_public_path__ + "img/reference45.83cdf3b8.jpg";